import { AutocompleteSuggestion } from "@/types/types";

export function getFilteredListingCountFromAutocomplete(
  suggestion: AutocompleteSuggestion,
  type: string,
  purpose: string
): number {
  const noType = !type || type === "any";
  const noPurpose = !purpose || purpose === "any";

  // --- CASE 0: No filters at all ---
  if (noType && noPurpose) return suggestion.listing_count;

  // --- CASE 1: Only purpose (type = any) ---
  if (noType && !noPurpose) {
    if (purpose === "for-sale") return suggestion.for_sale || 0;
    if (purpose === "for-rent") return suggestion.for_rent || 0;
    return suggestion.listing_count;
  }

  // --- CASE 2: Special combined type: apartment-house ---
  if (type === "apartment-house") {
    if (!noPurpose && purpose === "for-sale") {
      return (
        (suggestion.apartment_for_sale || 0) + (suggestion.house_for_sale || 0)
      );
    }
    if (!noPurpose && purpose === "for-rent") {
      return (
        (suggestion.apartment_for_rent || 0) + (suggestion.house_for_rent || 0)
      );
    }
    // purpose any
    return (suggestion.apartment || 0) + (suggestion.house || 0);
  }

  // --- CASE 3: Type selected, purpose any ---
  if (!noType && noPurpose) {
    const baseKey = type as keyof AutocompleteSuggestion;
    const value = suggestion[baseKey];
    return typeof value === "number" ? value : suggestion.listing_count;
  }

  // --- CASE 4: Explicit mapping for type + purpose ---
  const keyMap: Record<string, keyof AutocompleteSuggestion> = {
    apartment: "apartment",
    house: "house",
    land: "land",
    office: "office",

    "apartment-for-sale": "apartment_for_sale",
    "house-for-sale": "house_for_sale",
    "land-for-sale": "land_for_sale",
    "office-for-sale": "office_for_sale",

    "apartment-for-rent": "apartment_for_rent",
    "house-for-rent": "house_for_rent",
    "land-for-rent": "land_for_rent",
    "office-for-rent": "office_for_rent",
  };

  const lookupKey = `${type}-${purpose}`;
  const mappedKey = keyMap[lookupKey];

  if (mappedKey) {
    const value = suggestion[mappedKey];
    return typeof value === "number" ? value : 0;
  }

  // --- Fallback ---
  return suggestion.listing_count;
}
